import { namespaceCreator as createAccessibilityNamespace, createSuperAPIFactory as createAccessibilitySuperAPIFactory, } from './accessibility';
import { namespaceCreator as createRefComponentsNamespace, createSuperAPIFactory as createRefComponentsSuperAPIFactory, } from './refComponents';
export function createSuperAPIFactories(hostType, hostAPI, dsAPI) {
    return (context) => {
        return Object.assign(Object.assign({}, createAccessibilitySuperAPIFactory(hostType, hostAPI, dsAPI)(context)), createRefComponentsSuperAPIFactory(hostType, hostAPI, dsAPI)(context));
    };
}
export function createPlatformAPI(context, hostType, consumerType, version, superAPIFactory) {
    const superAPI = superAPIFactory(context);
    if (hostType === 'classic') {
        // classic
        return Object.assign(Object.assign({}, createAccessibilityNamespace({
            context,
            consumerType,
            hostType,
            version,
            superAPI: superAPI,
        })), createRefComponentsNamespace({
            context,
            consumerType,
            hostType,
            version,
            superAPI: superAPI,
        }));
    }
    else {
        // editorx
        return Object.assign(Object.assign({}, createAccessibilityNamespace({
            context,
            consumerType,
            hostType,
            version,
            superAPI: superAPI,
        })), createRefComponentsNamespace({
            context,
            consumerType,
            hostType,
            version,
            superAPI: superAPI,
        }));
    }
}
//# sourceMappingURL=index.js.map